import { Tooltip, theme } from 'antd'
import dayjs from 'dayjs'
import { FC } from 'react'
import PrintQueueEntry from '../../../../../../../../types/api/print-queue-entry'
import { hasEndTimeMachineMismatch } from '../../../../../helpers/build-print-queue-end-times'

interface EndTimeCellProps {
    record: PrintQueueEntry
    endAt?: string
}

const EndTimeCell: FC<EndTimeCellProps> = ({ record, endAt }) => {
    const { token } = theme.useToken()

    if (!endAt) {
        return null
    }

    const formatted = dayjs(endAt).format('DD.MM HH:mm')

    if (!hasEndTimeMachineMismatch(record)) {
        return <span>{formatted}</span>
    }

    return (
        <Tooltip title='Станок изменился или не был указан, время может отличаться'>
            <span style={{ color: token.colorWarningText || token.colorWarning }}>{formatted}</span>
        </Tooltip>
    )
}

export default EndTimeCell
